/* eslint-disable react/prop-types */
import {
  UilPlusCircle,
  UilPlus,
  UilPen,
  UilTrash,
  UilSearch,
  UilCheckCircle,
} from '@iconscout/react-unicons';
import {
  Button,
  ButtonGroup,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormLabel,
  Grid,
  IconButton,
  Notification,
  Paper,
  TextField,
} from '@xbotvn/mui';
import _ from 'lodash';
import React, {
  useMemo,
  useState,
} from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import { unitApi } from '../../api';
import SingleSelect from '../../components/SingleSelect';
import Table from '../../components/Table';
import Waiting from '../../components/Waiting';
import { ROLES } from '../../libs/utils';
import uuid from '../../libs/uuid';
import { UNIT } from '../../redux/actions/constants';
import MemberEditor from '../Admin/Member/MemberEditor';

export default function Xbot() {
  const dispatch = useDispatch();
  const {
    cities,
    userInfo,
  } = useSelector(({
    catalogs,
    user,
  }) => ({
    userInfo: user,
    cities: catalogs.system.cities.data,
  }));

  const [selectedProvince, setSelectedProvince] = useState('79');
  const [editor, setEditor] = useState();
  const [member, setMember] = useState();
  const [units, setUnits] = useState();

  const fetchUnits = async () => {
    if (!selectedProvince) {
      Notification.error('Vui lòng chọn Tỉnh');
      return;
    }
    const {
      data,
    } = await unitApi.getByProvince(selectedProvince);
    setUnits(data?.units);
  };

  const provinceOptions = useMemo(() => _.orderBy(_.map(cities, (data, key) => ({ label: data.name, value: key })), ['label'], ['asc']), [cities]);

  const wardOptions = useMemo(() => _.orderBy(_.map(cities?.[selectedProvince]?.wards || [], (data, key) => ({ label: data.name, value: key })), ['label'], ['asc']), [cities, selectedProvince]);

  const columns = [
    {
      Header: 'STT',
      id: 'stt',
      disableFilters: true,
      style: {
        width: 50,
        textAlign: 'center',
      },
      accessor: (e, index) => <div style={{ textAlign: 'center' }}>{index + 1}</div>,
    },
    {
      Header: 'Họ và tên',
      accessor: 'name',
      style: {
        width: 'auto',
      },
    },
    {
      Header: 'Email',
      accessor: 'email',
      style: {
        width: 500,
      },
    },
    {
      Header: 'Chức vụ',
      style: {
        width: 300,
      },
      accessor: ({
        role,
      }) => ROLES[role],
    },
    {
      Header: () => (
        <Button
          size="small"
          color="primary"
          variant="outlined"
          onClick={() => setMember({ name: '', email: '', role: '' })}
          startIcon={<UilPlus />}
        >
          Thêm
        </Button>
      ),
      style: {
        textAlign: 'center',
        width: 100,
      },
      id: 'add',
      disableFilters: true,
      Cell: (rowProps) => {
        const rowValue = _.get(rowProps, 'row.original', {});
        return (
          <ButtonGroup style={{ display: 'flex', justifyContent: 'center' }}>
            <IconButton
              onClick={() => setMember(rowValue)}
              icon="edit"
              size="small"
              color="primary"
              sx={{
                marginRight: 0.5,
              }}
            >
              <UilPen />
            </IconButton>
            <Divider orientation="vertical" flexItem />
            <IconButton
              color="error"
              size="small"
              variant="outlined"
              onClick={() => {
                const members = editor?.members;
                const memberIndex = _.findIndex(members, (value) => value._id === rowValue._id);
                if (memberIndex !== -1) {
                  members.splice(memberIndex, 1);
                  setEditor((prev) => ({
                    ...prev,
                    members,
                  }));
                }
              }}
              sx={{
                marginLeft: 0.5,
              }}
            >
              <UilTrash />
            </IconButton>

          </ButtonGroup>
        );
      },
    },
  ];

  const unitColumns = [
    {
      Header: 'STT',
      id: 'stt',
      disableFilters: true,
      style: {
        width: 50,
        textAlign: 'center',
      },
      Cell: ({
        row,
      }) => <div style={{ textAlign: 'center' }}>{row.index + 1}</div>,
    },
    {
      Header: 'Tên đơn vị',
      accessor: 'name',
      style: {
        width: 'auto',
      },
      Cell: ({ row, value }) => {
        const unit = row?.original;
        if (unit?.type === 'department') {
          const childCount = _.filter(units, { parentId: unit?._id }).length;
          if (childCount > 0) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>{value}</span>
                <span
                  style={{
                    minWidth: 18,
                    height: 18,
                    padding: '0 6px',
                    borderRadius: 999,
                    background: '#e53935',
                    color: '#fff',
                    fontSize: 12,
                    fontWeight: 700,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1,
                  }}
                >
                  {childCount}
                </span>
              </div>
            );
          }
        }
        return value;
      },
    },
    {
      Header: 'Phường/Xã',
      accessor: 'ward',
      style: {
        width: 250,
      },
      Filter: ({
        column: {
          filterValue,
          setFilter,
        },
      }) => (
        <SingleSelect
          options={wardOptions}
          value={filterValue}
          onChange={(val) => setFilter(val || undefined)}
          InputProps={{
            placeholder: 'Tất cả',
          }}
          clearable
        />
      ),
      Cell: ({
        value,
      }) => _.get(cities?.[selectedProvince]?.wards || [], [value, 'name'], ''),
    },
    {
      Header: 'Trực thuộc',
      accessor: 'parentId',
      style: {
        width: 250,
      },
      Filter: ({
        column: {
          filterValue,
          setFilter,
        },
      }) => (
        <SingleSelect
          options={_.map(_.filter(units, { type: 'department' }), (unit) => ({
            value: unit._id,
            label: unit.name,
          }))}
          value={filterValue}
          onChange={(val) => setFilter(val || undefined)}
          InputProps={{
            placeholder: 'Tất cả',
          }}
          clearable
          fullWidth
        />
      ),
      filter: (rows, id, filterValue) => {
        if (!filterValue) return rows;
        return rows.filter((row) => row?.values?.[id] === filterValue);
      },
      Cell: ({
        row,
        value,
      }) => {
        const unit = row?.original;
        if (unit?.type === 'th') {
          return _.get(_.find(units, { _id: value }), 'name', '');
        }
        return '';
      },
    },
    {
      Header: 'Địa chỉ',
      accessor: 'address',
      style: {
        width: 250,
      },
    },
    {
      Header: 'Sách trẻ em',
      disableFilters: true,
      style: {
        width: 100,
        textAlign: 'center',
      },
      accessor: ({
        config,
      }) => (config?.children ? <div style={{ textAlign: 'center' }}><UilCheckCircle color="green" /></div> : ''),
    },
    {
      id: 'edit',
      disableFilters: true,
      style: {
        width: 50,
      },
      Cell: (rowProps) => {
        const rowValue = _.get(rowProps, 'row.original', {});
        return (
          <ButtonGroup>
            <IconButton
              onClick={() => setEditor(rowValue)}
              icon="edit"
              size="small"
              color="primary"
              sx={{
                marginRight: 0.5,
              }}
            >
              <UilPen />
            </IconButton>
          </ButtonGroup>
        );
      },
    },
  ];

  const renderEditor = () => (
    <Dialog
      open={!!editor}
      onClose={() => setEditor()}
      fullWidth
      maxWidth="xl"
    >
      <DialogTitle>Thêm đơn vị</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mb={1}>
          <Grid item xs={6}>
            <TextField
              value={_.get(editor, 'name', '')}
              label="Tên đơn vị"
              required
              onChange={(e) => setEditor((prev) => ({
                ...prev,
                name: e.target.value,
              }))}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <FormLabel required>Phường/Xã</FormLabel>
            <SingleSelect
              InputProps={{
                placeholder: 'Chọn phường/xã',
                required: true,
              }}
              options={wardOptions}
              value={_.get(editor, 'ward', '')}
              onChange={(value) => setEditor((prev) => ({
                ...prev,
                ward: value,
              }))}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              value={_.get(editor, 'address', '')}
              label="Địa chỉ"
              required
              onChange={(e) => setEditor((prev) => ({
                ...prev,
                address: e.target.value,
              }))}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <FormLabel required>Loại đơn vị</FormLabel>
            <SingleSelect
              InputProps={{
                placeholder: 'Chọn loại đơn vị',
                required: true,
              }}
              options={[{ value: 'th', label: 'Trường học' }, { value: 'department', label: 'Phòng/Ban/Cụm' }]}
              value={_.get(editor, 'type', '')}
              onChange={(value) => setEditor((prev) => ({
                ...prev,
                type: value,
              }))}
            />
          </Grid>
          {editor?.type === 'th' && (
            <Grid item xs={3}>
              <FormLabel>Trực thuộc</FormLabel>
              <SingleSelect
                InputProps={{
                  placeholder: 'Chọn đơn vị quản lý',
                }}
                options={_.map(_.filter(units, (unit) => unit.type === 'department'), (unit) => ({ value: unit._id, label: unit.name }))}
                value={_.get(editor, 'parentId', '')}
                onChange={(value) => setEditor((prev) => ({
                  ...prev,
                  parentId: value,
                }))}
              />
            </Grid>
          )}
          <Grid item xs={3}>
            <FormLabel>Sách cho trẻ</FormLabel>
            <Checkbox
              checked={_.get(editor, 'config.children', false)}
              onChange={() => setEditor((prev) => ({
                ...prev,
                config: {
                  ...prev.config,
                  children: !prev?.config?.children,
                },
              }))}
            />
          </Grid>
        </Grid>
        <Table
          columns={columns}
          data={editor?.members}
          disableGlobalFilter
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="success"
          icon="saved"
          onClick={() => {
            const onSuccess = () => fetchUnits();
            if (editor._id) {
              dispatch({
                type: UNIT.handlers.update,
                data: editor,
                onSuccess,
              });
            } else {
              dispatch({
                type: UNIT.handlers.create,
                data: editor,
                onSuccess,
              });
            }
            setEditor();
          }}
        >
          Lưu
        </Button>
        <Button color="error" icon="cross" onClick={() => setEditor()}>Đóng</Button>
      </DialogActions>
    </Dialog>
  );

  const renderMemberEditor = () => (
    <MemberEditor
      title={member?._id ? 'Sửa thành viên' : 'Thêm Thành Viên'}
      onClose={() => setMember()}
      onHandler={(params) => {
        const _id = member?._id || uuid();
        const newMember = { ...params, _id };
        const valueExsit = _.find(editor?.members,
          (value) => value?.email?.toLowerCase() === newMember?.email?.toLowerCase() && value._id !== newMember._id);

        if (valueExsit?.email) {
          Notification.warn('Đã tồn tại Email này trong hệ thống');
          return;
        }
        const newMembers = editor?.members || [];
        const memberIndex = _.findIndex(newMembers, (value) => value._id === _id);
        if (memberIndex !== -1) {
          newMembers[memberIndex] = newMember;
        } else {
          newMembers.push(newMember);
        }
        setEditor((prev) => ({
          ...prev,
          members: newMembers,
        }));
        setMember();
      }}
      data={member}
    />
  );

  if (userInfo.handling) return <Waiting message="Đang lấy dữ liệu" />;

  return userInfo?.support ? (
    <Paper elevation={3} style={{ padding: 20 }}>
      {renderEditor()}
      {member && renderMemberEditor()}
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <SingleSelect
            options={provinceOptions}
            value={selectedProvince}
            onChange={(value) => {
              setSelectedProvince(value);
            }}
            InputProps={{
              placeholder: 'Chọn tỉnh',
              required: true,
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <Button
            style={{ marginLeft: 20, marginTop: 7 }}
            onClick={() => fetchUnits()}
            startIcon={<UilSearch />}
          >
            Tra cứu
          </Button>
          <Button
            style={{ marginLeft: 20, marginTop: 7 }}
            color="primary"
            onClick={() => {
              if (!selectedProvince) {
                Notification.error('Vui lòng chọn Tỉnh/Thành');
                return;
              }
              setEditor({
                province: selectedProvince,
                name: '',
                address: '',
                members: [],
                type: 'th',
              });
            }}
            startIcon={<UilPlusCircle />}
          >
            Thêm đơn vị
          </Button>
        </Grid>
        {_.size(units) ? (
          <Grid item xs={12}>
            <Table columns={unitColumns} data={units} alwaysShowPagination />
          </Grid>
        ) : null}
      </Grid>
    </Paper>
  ) : <div>Bạn không phải là nhân viên công ty</div>;
}
